import React, { useState } from 'react';
import CustomIcon from '../Common/CustomIcon/CustomIcon';
import styles from './DuplicateComponents.module.css';

export const DuplicateButton = ({
	onOpenModal,
	hasChanges,
	handleSave,
	isSaving = false,
	itemName = 'Item',
}) => {
	const [
		isForceSaving,
		setIsForceSaving,
	] = useState(false);

	const handleClick = async () => {
		if (hasChanges) {
			setIsForceSaving(true);
			try {
				await handleSave();
			} catch (e) {
				window.alert('Error saving changes. Please try again before duplicating.');
				setIsForceSaving(false);
				return;
			}
			setIsForceSaving(false);
		}
		onOpenModal();
	};

	const isDisabled = isSaving || isForceSaving;

	return (
		<button
			className={`button ${isDisabled ? 'button-disabled' : ''} ${styles.duplicateBtn}`}
			onClick={handleClick}
			disabled={isDisabled}
			title={isDisabled ? 'Saving...' : `Duplicate this ${itemName}`}
			data-test-id="duplicateButton"
		>
			<CustomIcon icon="copy" />
			Duplicate
		</button>
	);
};

export const DuplicateModal = ({
	app,
	onDuplicate,
	itemName = 'Item',
}) => {
	const [
		count,
		setCount,
	] = useState(1);
	const [
		isDuplicating,
		setIsDuplicating,
	] = useState(false);
	const [
		errorMsg,
		setErrorMsg,
	] = useState('');

	const normalizedCount = typeof count === 'string' ? count.trim() : count;
	const countNum = Number(normalizedCount);
	const isValid = normalizedCount !== '' && Number.isInteger(countNum) && countNum >= 1 && countNum <= 10;

	const handleDuplicate = async () => {
		if (!isValid || isDuplicating) {
			return;
		}
		setIsDuplicating(true);
		setErrorMsg('');
		try {
			await onDuplicate(countNum);
			app.closeModal();
		} catch (e) {
			setErrorMsg(e.toString());
			setIsDuplicating(false);
		}
	};

	return (
		<div className={styles.duplicateModalBody}>
			<div className={styles.duplicateModalFormGroup}>
				<label htmlFor="dup-count">
					How many versions of this {itemName}?
					<input
						id="dup-count"
						type="number"
						min={1}
						max={10}
						value={count}
						autoFocus
						data-test-id="duplicateCountInput"
						className={styles.duplicateModalInput}
						onChange={(e) => {
							setCount(e.target.value);
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								e.preventDefault();
								handleDuplicate();
							}
						}}
					/>
				</label>
				{!isValid && String(count) !== '' && (
					<p className={styles.duplicateModalError}>
						Please enter a number between 1 and 10.
					</p>
				)}
				{errorMsg && (
					<p className={styles.duplicateModalError}>
						{errorMsg}
					</p>
				)}
			</div>
			<div className={styles.duplicateModalFooter}>
				<button
					className={`button ${styles.duplicateModalCancelBtn}`}
					disabled={isDuplicating}
					onClick={() => {
						app.closeModal();
					}}
				>
					<div>Cancel</div>
				</button>
				<button
					className={`button ${styles.duplicateModalActionBtn}`}
					disabled={!isValid || isDuplicating}
					onClick={handleDuplicate}
					data-test-id="duplicateConfirmButton"
				>
					<CustomIcon icon="copy" />
					<div>{isDuplicating ? 'Duplicating...' : 'Duplicate'}</div>
				</button>
			</div>
		</div>
	);
};
